import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { size = 24, color = '#D44333', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path
        stroke={color}
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M11.766 20.566a9 9 0 100-18 9 9 0 000 18z"
      />
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M14.766 8.566l-6 6M14.766 14.566l-6-6"
      />
    </svg>
  );
}

export default Icon;
